import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class RulesSettingsService {
  onSave$ = new Subject();
  constructor() {}

  save() {
    this.onSave$.next(null);
  }
}
